<template>
  <div>
    <v-divider class="my-3" />
    <h4 class="d-flex align-center">
      <span class="ml-5 py-2">{{ text }}</span>
      <v-icon
        v-show="status > 0"
        size="34"
        class="ml-auto mr-5"
        :color="status === 1 ? 'green' : 'red'"
      >
        mdi-{{ status === 1 ? 'check' : 'alert' }}-circle
      </v-icon>
    </h4>
  </div>
</template>

<script>
export default {
  name: 'PaxConfigLine',

  props: {
    text: { type: String, default: '' },
    status: { type: Number, default: 0 }
  }
}
</script>
